import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import SEO from "@/components/SEO";

const MentionsLegalesPage = () => {
  const { t } = useTranslation();

  return (
    <main className="pt-20 bg-[#EDEBE4]" data-testid="mentions-legales-page">
      <SEO title="Mentions Légales" path="/mentions-legales" description="Mentions légales du site ALTURA Conciergerie — AD MOBILITÉ SASU. Informations juridiques, éditeur, hébergeur." noindex />

      <section className="py-16 sm:py-24">
        <div className="max-w-3xl mx-auto px-6 sm:px-12">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
            <h1 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-normal text-[#1A1A1A] mb-12">
              Mentions légales
            </h1>

            <div className="space-y-10 text-[#1A1A1A]/80 text-sm font-light leading-relaxed">

              <div>
                <h2 className="font-heading text-xl text-[#1A1A1A] mb-4">1. Éditeur du site</h2>
                <p>Le site <strong>alturaconciergerie.com</strong> est édité par :</p>
                <ul className="mt-3 space-y-1">
                  <li><strong>Raison sociale :</strong> AD MOBILITÉ</li>
                  <li><strong>Forme juridique :</strong> SASU (Société par Actions Simplifiée Unipersonnelle)</li>
                  <li><strong>SIRET :</strong> 981 338 403 00018</li>
                  <li><strong>Siège social :</strong> 19 rue des Sablières, 78410 Aubergenville, France</li>
                  <li><strong>Nom commercial :</strong> ALTURA Conciergerie</li>
                  <li><strong>Directeur de la publication :</strong> Adrien Garcia, Président</li>
                  <li><strong>Email :</strong> contact@alturaconciergerie.com</li>
                  <li><strong>Téléphone :</strong> +33 6 81 96 93 42</li>
                </ul>
              </div>

              <div>
                <h2 className="font-heading text-xl text-[#1A1A1A] mb-4">2. Hébergement</h2>
                <p>Le site est hébergé par :</p>
                <ul className="mt-3 space-y-1">
                  <li><strong>Railway Corp.</strong></li>
                  <li>548 Market St, PMB 70269, San Francisco, CA 94104, États-Unis</li>
                  <li>Site web : <a href="https://railway.app" target="_blank" rel="noopener noreferrer" className="underline hover:text-[#1A1A1A]">railway.app</a></li>
                </ul>
              </div>

              <div>
                <h2 className="font-heading text-xl text-[#1A1A1A] mb-4">3. Propriété intellectuelle</h2>
                <p>
                  L'ensemble du contenu du site alturaconciergerie.com (textes, images, graphismes, logo, icônes, vidéos, etc.) est la propriété exclusive de AD MOBILITÉ ou de ses partenaires et est protégé par les lois françaises et internationales relatives à la propriété intellectuelle.
                </p>
                <p className="mt-3">
                  Toute reproduction, représentation, modification, publication, distribution ou retransmission, totale ou partielle, du contenu du site est strictement interdite sans l'autorisation écrite préalable de AD MOBILITÉ.
                </p>
              </div>

              <div>
                <h2 className="font-heading text-xl text-[#1A1A1A] mb-4">4. Responsabilité</h2>
                <p>
                  AD MOBILITÉ s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées sur ce site. Toutefois, AD MOBILITÉ ne peut garantir l'exactitude, la précision ou l'exhaustivité des informations mises à disposition sur ce site.
                </p>
                <p className="mt-3">
                  AD MOBILITÉ décline toute responsabilité pour toute imprécision, inexactitude ou omission portant sur des informations disponibles sur le site, ainsi que pour tous dommages résultant d'une intrusion frauduleuse d'un tiers ayant entraîné une modification des informations mises à disposition sur le site.
                </p>
              </div>

              <div>
                <h2 className="font-heading text-xl text-[#1A1A1A] mb-4">5. Liens hypertextes</h2>
                <p>
                  Le site alturaconciergerie.com peut contenir des liens hypertextes vers d'autres sites. AD MOBILITÉ ne dispose d'aucun moyen de contrôle du contenu de ces sites tiers et n'assume aucune responsabilité quant à leur contenu.
                </p>
              </div>

              <div>
                <h2 className="font-heading text-xl text-[#1A1A1A] mb-4">6. Droit applicable</h2>
                <p>
                  Les présentes mentions légales sont soumises au droit français. En cas de litige, et après tentative de résolution amiable, les tribunaux français seront seuls compétents.
                </p>
              </div>

              <div>
                <h2 className="font-heading text-xl text-[#1A1A1A] mb-4">7. Contact</h2>
                <p>
                  Pour toute question relative aux présentes mentions légales, vous pouvez nous contacter à l'adresse suivante : <a href="mailto:contact@alturaconciergerie.com" className="underline hover:text-[#1A1A1A]">contact@alturaconciergerie.com</a>
                </p>
              </div>

            </div>

            <p className="mt-12 text-[#1A1A1A]/40 text-xs">Dernière mise à jour : février 2026</p>
          </motion.div>
        </div>
      </section>
    </main>
  );
};

export default MentionsLegalesPage;
